module.exports = __webpack_public_path__ + "img/ok.371649b3.svg";